import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  IconButton,
  Divider,
  Tooltip,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ExpandLess,
  ExpandMore,
  LibraryBooks as LibraryBooksIcon,
  Link as LinkIcon,
  Campaign as CampaignIcon,
  LocalOffer as LocalOfferIcon,
  HelpOutline as HelpOutlineIcon,
  EmojiPeople as EmojiPeopleIcon,
  Image as ImageIcon,
  Notifications as NotificationsIcon,
  Storage as StorageIcon,
} from "@mui/icons-material";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MessageIcon from "@mui/icons-material/Message";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import PersonIcon from "@mui/icons-material/Person";
import NavBar from "./NavBar";
import { useAuth } from "./access/AuthContext";
import SIALogo from "../assets/SIALogo.png";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SchoolIcon from "@mui/icons-material/School";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DiscountIcon from "@mui/icons-material/Discount";
import AddLinkIcon from "@mui/icons-material/AddLink";
const menuItems = [
  {
    label: "Books List",
    icon: <LibraryBooksIcon />,
    path: "/booklist",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Course Book Mapping",
    icon: <LinkIcon />,
    path: "/courseBookMapping",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Academics",
    icon: <SchoolIcon />,
    path: "/academics",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Mentorship",
    icon: <CoPresentIcon />,
    path: "/mentorship",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Assessment",
    icon: <AssignmentIcon />,
    path: "/assessment",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Reports",
    icon: <StorageIcon />,
    path: "/dbdata",
    roles: ["ADMIN", "ALL_FUNCTIONS", "MARKETING"],
  },
  // {
  //   label: "Sales Dashboard",
  //   icon: <DashboardIcon />,
  //   path: "/SalesDashboard",
  //   roles: ["ADMIN", "ALL_FUNCTIONS"],
  // },
  {
    label: "News Updates",
    icon: <CampaignIcon />,
    path: "/updates",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Coupons",
    icon: <LocalOfferIcon />,
    path: "/Coupons",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR", "OPS"],
  },
  {
    label: "Combo Discount",
    icon: <DiscountIcon />,
    path: "/comboDiscount",
    roles: ["ADMIN", "ALL_FUNCTIONS"],
  },
  {
    label: "Campaign Links",
    icon: <AddLinkIcon />,
    path: "/campaign-links",
    roles: ["ADMIN", "ALL_FUNCTIONS", "MARKETING"],
  },
  {
    label: "Users",
    icon: <PersonIcon />,
    path: "/Users",
    roles: ["ADMIN", "ALL_FUNCTIONS", "OPS"],
  },
  {
    label: "FAQs",
    icon: <HelpOutlineIcon />,
    path: "/FaqManagement",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Testimonial",
    icon: <EmojiPeopleIcon />,
    path: "/TestimonialManagement",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  // {
  //   label: "MasterClass",
  //   icon: <EmojiPeopleIcon />,
  //   path: "/masterClasses",
  //   roles: ["ADMIN", "ALL_FUNCTIONS"],
  // },

  {
    label: "Banners",
    icon: <ImageIcon />,
    path: "/BannerManagement",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Notify Me",
    icon: <NotificationsIcon />,
    path: "/notification",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },

  {
    label: "Messages",
    icon: <MessageIcon />,
    path: "/messages",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Subscriptions",
    icon: <SubscriptionsIcon />,
    path: "/Subscriptions",
    roles: ["ADMIN", "ALL_FUNCTIONS", "EDITOR"],
  },
  {
    label: "Admin Management",
    icon: <SupervisorAccountIcon />,
    path: "/admin/dashboard",
    roles: ["ALL_FUNCTIONS"],
  },
];

function Sidebar() {
  const [openMenus, setOpenMenus] = useState({});
  const [collapsed, setCollapsed] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { role } = useAuth();
  const roles = Array.isArray(role) ? role : [role];
  console.log(roles);

  useEffect(() => {
    localStorage.setItem("lastVisited", location.pathname);
  }, [location.pathname]);

  const handleToggleMenu = (label) => {
    setOpenMenus((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const handleNavigate = (path) => navigate(path);
  //   const isActive = (path) => location.pathname.startsWith(path);

  const isActive = (item) => {
    const current = location.pathname;
    if (item.label === "Books List") {
      return (
        current.startsWith("/booklist") ||
        current.startsWith("/bookform") ||
        current.startsWith("/selectedbook") ||
        current.startsWith("/reprocess-status")
      );
    }
    if (item.label === "Colleges") {
      return (
        current.startsWith("/collegeManagement") ||
        current.startsWith("/college_courses")
      );
    }
    if (item.label === "Banners") {
      return (
        current.startsWith("/BannerManagement") ||
        current.startsWith("/advertisement-course-mapping") ||
        current.startsWith("/pop-up-course-mapping") ||
        current.startsWith("/banner-course-mapping")
      );
    }
    if (item.label === "Academics") {
      return (
        current.startsWith("/academics") ||
        current.startsWith("/CourseCollegeMap")
      );
    }
    if (item.label === "Course Book Mapping") {
      return (
        current.startsWith("/courseBookMapping") ||
        current.startsWith("/mentorship/subjects")
      );
    }
    if (item.label === "Mentorship") {
      return (
        current.startsWith("/mentorship") &&
        !current.startsWith("/mentorship/subjects")
      );
    }
    return current.startsWith(item.path);
  };
  // Filter menus based on role
  const visibleMenuItems = menuItems.filter(
    (item) =>
      roles.includes("ALL_FUNCTIONS") ||
      item.roles.some((r) => roles.includes(r)),
  );
  console.log(visibleMenuItems);

  return (
    <React.Fragment>
      <NavBar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <Box sx={{ display: "flex" }}>
        {/* ===== Sidebar Drawer ===== */}
        <Drawer
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          variant="permanent"
          sx={{
            display: { xs: "none", md: "flex" },
            width: collapsed ? 70 : 240,
            flexShrink: 0,
            transition: "width 0.3s ease",
            [`& .MuiDrawer-paper`]: {
              width: collapsed ? 70 : 240,
              transition: "width 0.3s ease",
              boxSizing: "border-box",
              mt: "85px",
              height: "calc(100vh - 85px)",
              position: "fixed",
              overflowX: "hidden",
            },
          }}
        >
          {/* Sidebar Header / Toggle Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: collapsed ? "center" : "flex-end",
              alignItems: "center",
              p: 1,
            }}
          >
            <IconButton
              onClick={() => setCollapsed(!collapsed)}
              sx={{
                color: collapsed ? "primary.main" : "text.primary",
                transition: "color 0.3s ease, transform 0.3s ease",
                "&:hover": {
                  color: "primary.main",
                  transform: "scale(1.1)",
                },
              }}
            >
              {collapsed ? (
                <MenuIcon fontSize="medium" />
              ) : (
                <MenuOpenIcon fontSize="medium" />
              )}
            </IconButton>
          </Box>

          <Divider />

          {/* Sidebar Items */}
          <List>
            {visibleMenuItems.map((item) => (
              <Tooltip
                key={item.label}
                title={collapsed ? item.label : ""}
                placement="right"
                arrow
              >
                <Box>
                  <ListItemButton
                    onClick={() => handleNavigate(item.path)}
                    sx={{
                      px: collapsed ? 2 : 3,
                      justifyContent: collapsed ? "center" : "flex-start",
                      backgroundColor: isActive(item)
                        ? "#17469e29"
                        : "transparent",
                      "&:hover": {
                        backgroundColor: "#17469e29",
                        color: "#17479e",
                      },
                      color: isActive(item) ? "#17479e" : "#747373ff",
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: collapsed ? "unset" : 40,
                        color: isActive(item.path) ? "primary.main" : "inherit",
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    {!collapsed && (
                      <ListItemText
                        primary={item.label}
                        sx={{
                          color: isActive(item.path)
                            ? "primary.main"
                            : "inherit",
                          fontWeight: isActive(item.path) ? 600 : 400,
                        }}
                      />
                    )}
                  </ListItemButton>
                </Box>
              </Tooltip>
            ))}
          </List>
        </Drawer>
        {/* ===== Mobile Sidebar Drawer ===== */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          sx={{
            display: { xs: "flex", md: "none" },
            [`& .MuiDrawer-paper`]: {
              width: 240,
              boxSizing: "border-box",
              pt: "10px",
            },
          }}
        >
          {/* Sidebar Header / Toggle Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: mobileOpen ? "space-between" : "flex-end",
              alignItems: "center",
              p: 1,
            }}
          >
            <IconButton edge="start" color="inherit" aria-label="logo">
              <Box
                component="img"
                src={SIALogo}
                alt="sia logo"
                sx={{ paddingLeft: "8px", width: "40px" }}
              />
            </IconButton>
            <IconButton
              onClick={() => setMobileOpen(!mobileOpen)}
              sx={{
                color: mobileOpen ? "primary.main" : "text.primary",
                transition: "color 0.3s ease, transform 0.3s ease",
                "&:hover": {
                  color: "primary.main",
                  transform: "scale(1.1)",
                },
              }}
            >
              {mobileOpen ? (
                <MenuOpenIcon fontSize="medium" />
              ) : (
                <MenuIcon fontSize="medium" />
              )}
            </IconButton>
          </Box>

          <Divider />
          <List>
            {visibleMenuItems.map((item) => (
              <Tooltip
                key={item.label}
                title={!mobileOpen ? item.label : ""}
                placement="right"
                arrow
              >
                <ListItemButton
                  onClick={() => {
                    navigate(item.path); // navigate to the route
                    setMobileOpen(false); // close drawer after click
                  }}
                  sx={{
                    px: 2,
                    justifyContent: mobileOpen ? "flex-start" : "center",
                    backgroundColor: isActive(item)
                      ? "#17469e29"
                      : "transparent",
                    "&:hover": {
                      backgroundColor: "#17469e29",
                      color: "#17479e",
                    },
                    color: isActive(item) ? "#17479e" : "#747373ff",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 40,
                      color: isActive(item.path) ? "primary.main" : "inherit",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>

                  {mobileOpen && (
                    <ListItemText
                      primary={item.label}
                      sx={{
                        color: isActive(item.path) ? "primary.main" : "inherit",
                        fontWeight: isActive(item.path) ? 600 : 400,
                      }}
                    />
                  )}
                </ListItemButton>
              </Tooltip>
            ))}
          </List>
        </Drawer>

        {/* ===== Main Content Area ===== */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundColor: "#f9f9f9",
            minHeight: "calc(100vh - 85px)",
            overflowY: "auto",
            mt: "85px",
            ml: collapsed ? "0px" : "0px",
            transition: "margin 0.3s ease",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default Sidebar;
